import React, { useState, useEffect, useContext } from 'react';
import {observer} from "mobx-react";

import * as net from "../../lib/net";
import ddo from "../../ddo";

import Avd_Edit from "./fkn/avd_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Lag_Srt extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;

    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.sta = [];
    this.state.aa = [];
    this.state.wnds = {};
    if(this.pos.deps) this.state.aa = this.pos.deps;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.srts();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  srt_edit(row) {
    var self = this;
    //alert(JSON.stringify(row.bet00));
    //var bto = JSON.parse(JSON.stringify(row.bet00));
    var wnds = {};
    wnds.srtedit = true;
    wnds.vgo = row;
    wnds.backdrop = true;
    self.setState({wnds: wnds });
  }

  srts() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_srt.srts";
    prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({sta: ret.rco });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  change_avd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({avd: avd});
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control w250" value={this.state.avd} placeholder="Välj avdelning" onChange={(e) => this.change_avd(e)}>
            { this.props.store.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text}</option>
            )}
        </select>
        <div className="flex"></div>

        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.vgrps() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>Kstns</th>
                <th>SortID</th>
                <th>Rader</th>
                <th>Uppdat</th>
                <th style={{width:"40px"}} ></th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.sta.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.srt_edit(row) }>
                <td>{ row.s0kstns }</td>
                <td>{ row.sorttab }</td>
                <td>{ row.nrr }</td>
                <td>{ row.upddat }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.vgrp_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    { this.state.wnds.vgrpedit ? <Avd_Edit wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
  );
    }
}
export default observer(Lag_Srt);
